export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/bg/rawpixel-comm-9fb6ea215843ca6f4d9e8ddb4722ac26.jpg";